export const store = {
    state: {
        random: true,
        inverted: false,
        fullscreen: false,
        totalImages: 0,
        projects: [],
        allProjects: [],
        orderedImages: [],
        allImages: [],
        shuffledImages: [],
        swipeImages: [],
        sorting: "year_order",
        sortingOrder: -1,
        splashPage: false,
        splashAllowed: true,
        afterSplashName: "swipe",
        afterSplashSlug: "",
        afterSplashId: 0,
        randomIndex: 0,
        orderedIndex: 0,
        activeSlug: "",
        lastSlug: "",
        activeID: "",
        currentImage: null,
        isMobile: false,
        lastIndex: "index",
        lastAbout: "studio",
        lastSwipe: "/dev/",
        lastProject: "project-list-identities",
        detailTransition: "",
        indexTransition: "",
        imagesTransition: "",
        landing: true,
        indexMounted: false,
        imagesMounted: false,
        prevRoute: "",
        imagesReady: false,
        currentSwipeID: null,
        lastSwipeIDX: -1
    }
};
